import { useEffect, useState } from "react";
import { Badge, Card, Tag } from "antd";
import { getSubjectName, getTeacherName } from "../../utils/academy.js";
import { todayTimetable } from "./academyTimetable.js";

const courseTitle = (course, subjects) => {
  const level = ({ 초등: "초", 중등: "중", 고등: "고" })[course.schoolLevel];
  const grade = course.schoolLevel === "재수" ? "재수" : level ? `${level}${course.grade || ""}` : "";
  return [grade, getSubjectName(subjects, course.subjectId, course.subject), course.className]
    .filter(value => value && value !== "-").join(" ");
};

export function TodayTimetableCards({ courses, subjects, teachers }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const refresh = () => setNow(new Date());
    const timer = setInterval(refresh, 1000);
    globalThis.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      clearInterval(timer);
      globalThis.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);
  const status = todayTimetable(courses, now);
  return (
    <div className="timetable-live-cards">
      {[["진행 중", status.current, "현재 진행 중인 수업·클리닉이 없습니다."], [
        "다음 수업",
        status.next,
        "예정된 수업·클리닉이 없습니다.",
      ]].map(([title, items, empty]) => (
        <Card
          key={title}
          title={(
            <span className="timetable-live-title">
              <Badge status={title === "진행 중" && items.length ? "success" : "default"} aria-hidden="true" />
              <span>{title}</span>
            </span>
          )}
          extra={<span className="timetable-live-clock">{status.label}</span>}
          className="academy-management-card timetable-live-card"
        >
          {items.length
            ? (
              <ul className="timetable-live-list">
                {items.map((item) => (
                  <li key={item.id}>
                    <div className="timetable-live-item-title">
                      <strong>
                        {courseTitle(item.course, subjects)}
                      </strong>
                      {item.kind === "clinic" && <Tag>클리닉</Tag>}
                    </div>
                    <div className="timetable-live-item-meta">
                      <span>
                        {item.course.assignmentVisible === false
                          ? "담당 미표시"
                          : getTeacherName(teachers, item.course.teacherId)}{item.startsAt}~{item.endsAt}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )
            : <div className="timetable-live-empty">{empty}</div>}
        </Card>
      ))}
    </div>
  );
}
